import React from "react";
import { useParams } from "react-router-dom";
import SEO from "@/components/SEO";
import { useSettings } from "@/context/SettingsContext";

const CONTENT = {
  "privacy-policy": {
    title: "Privacy Policy",
    body: [
      "This Privacy Policy explains how Mathura Homes ('we', 'us') collects, uses and protects the information you provide when using our website.",
      "Information We Collect: We collect information you submit through enquiry forms, including your name, mobile number, email address and property preferences.",
      "How We Use Your Information: We use your details solely to respond to your enquiries, provide property recommendations and share relevant updates. We do not sell your data to third parties.",
      "Data Sharing: We may share your enquiry with our developer partners only to fulfil your property request, and with service providers who help us operate our website.",
      "Cookies: Our website uses cookies to improve your experience and analyse traffic. You can control cookies through your browser settings.",
      "Your Rights: You may request access to, correction of, or deletion of your personal data by contacting us.",
      "[This is an editable template. Please review with a legal professional and update to reflect your actual data practices.]",
    ],
  },
  "terms-and-conditions": {
    title: "Terms and Conditions",
    body: [
      "By accessing and using this website, you agree to these Terms and Conditions.",
      "Nature of Service: Mathura Homes acts as a real estate channel partner and property consultant. We are not the developer/builder of the projects listed.",
      "Information Accuracy: All project details, prices, images and availability are indicative and provided for general information. They are subject to change and must be verified with the respective developer.",
      "No Warranty: We make no warranties regarding the completeness or accuracy of the content on this website.",
      "Intellectual Property: All content on this website is the property of Mathura Homes unless otherwise stated.",
      "[This is an editable template. Please review with a legal professional before publishing.]",
    ],
  },
  "disclaimer": {
    title: "Disclaimer",
    body: [
      "Mathura Homes is a real estate channel partner / property consultant and is NOT the developer or builder of any project displayed on this website.",
      "All information — including prices, floor plans, specifications, amenities, images and possession dates — is indicative, for representation purposes only, and subject to change without notice.",
      "Prospective buyers must independently verify all details, approvals and RERA registration directly with the respective developer before making any purchase decision.",
      "Mathura Homes shall not be liable for any decision made based on the information presented on this website.",
    ],
  },
  "cookie-policy": {
    title: "Cookie Policy",
    body: [
      "This Cookie Policy explains how Mathura Homes uses cookies and similar technologies on our website.",
      "What Are Cookies: Cookies are small text files stored on your device that help websites function and gather analytics.",
      "How We Use Cookies: We use cookies to remember your preferences, understand how you use our website and improve your browsing experience.",
      "Managing Cookies: You can accept or decline cookies via the consent banner, or manage them through your browser settings.",
      "[This is an editable template. Update to reflect the specific cookies and analytics tools you use.]",
    ],
  },
  "rera-disclaimer": {
    title: "RERA Disclaimer",
    body: [
      "Mathura Homes operates as a real estate channel partner / property consultant.",
      "All projects displayed are marketed on behalf of the respective developers. RERA registration numbers, where shown, belong to the respective projects/developers.",
      "Buyers are advised to verify the RERA registration and project details on the official Karnataka RERA portal (rera.karnataka.gov.in) before making any commitment.",
      "Prices, plans, specifications and offers are subject to change and must be confirmed with the developer.",
      "[Add your own RERA agent registration number here, if applicable, via the admin dashboard.]",
    ],
  },
};

export default function Legal() {
  const { page } = useParams();
  const { settings } = useSettings();
  const data = CONTENT[page] || { title: "Page", body: ["Content not available."] };
  return (
    <div>
      <SEO title={`${data.title} | ${settings?.brand_name || "Mathura Homes"}`} description={`${data.title} for Mathura Homes.`} />
      <section className="bg-navy py-16 text-center"><h1 className="font-display text-4xl text-white">{data.title}</h1></section>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-14 space-y-5" data-testid="legal-content">
        {data.body.map((para, i) => <p key={i} className="text-muted-foreground leading-relaxed">{para}</p>)}
        <p className="text-xs text-muted-foreground pt-6 border-t border-gray-100">Last updated: {new Date().toLocaleDateString()}</p>
      </article>
    </div>
  );
}
